import { render } from "./MenuProfile.vue?vue&type=template&id=60af1d55&scoped=true"
import script from "./MenuProfile.vue?vue&type=script&lang=js"
export * from "./MenuProfile.vue?vue&type=script&lang=js"

import "./MenuProfile.vue?vue&type=style&index=0&id=60af1d55&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60af1d55"]])

export default __exports__